<div class='portal-data-element-list-indicator-element-display'>
  <div fxLayout='row' fxLayoutGap='4px'>
    <span class='xxxs-regular dsp-color-text-quiet'>{{ itemName }}</span>
    <app-icon-tool-tip *ngIf='tooltipText' [matTooltipInfo]='tooltipText'></app-icon-tool-tip>
  </div>
  <div class='indicator-nb-container'>
    <div *ngIf='nbNotCompleted !== undefined' class='indicator-nb-display'>
      <app-indicator-dot [isIndicatorSuccess]='false'></app-indicator-dot>
      <span class='l-semi-bold dsp-color-text-neutral'>{{ nbNotCompleted }}</span>
    </div>
    <div *ngIf='nbNotCompleted !== undefined' class='indicator-nb-display'>
      <app-indicator-dot [isIndicatorSuccess]='true'></app-indicator-dot>
      <span class='l-semi-bold dsp-color-text-neutral'>{{ nbCompleted }}</span>
    </div>
    <div *ngIf='nbDisplay !== undefined' class='indicator-nb-display'>
      <span class='l-semi-bold dsp-color-text-neutral'>{{ nbDisplay }}</span>
    </div>
  </div>
</div>
